<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span>Contemporary Approaches to Film and Media Series</p>
<p class="serpf">A complete listing of the books in this series can be found online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a>.</p>
<p class="serah">General Editor</p>
<p class="sered">Barry Keith Grant</p>
<p class="ser1">Brock University</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-scheibel-0003.vue?464dc8cc